import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../index.scss";

class Toaster {
  waitingPromis = async (callBackFuction, pendingMsg, successMsg, options: ToastOptions) => {
    const msg = {
      pending: {
        render() {
          return pendingMsg;
        }
      },
      success: {
        render() {
          return successMsg;
        }
      },
      error: {
        render({ data }) {
          return `${data?.message}`;
        }
      },
      
    };
    await toast.promise(callBackFuction, msg, options);
  };

  error = (message, options: ToastOptions) => toast.error(message, {...options});
  success = (message, options: ToastOptions) => toast.success(message, {...options});
}

export const toastAlert = new Toaster();
